import { biRollingLabel } from '@euler/app/components/message/widgets/bi-visualization/functions/biTimeRangeLabel';
import { BiDateFilterUse } from '@euler/model/bi/dashboard';
import { BiTimeGrain, BiTimeRangeKind } from '@euler/model/bi/query';
import { BiChartViz, BiKpiCompare, BiVizType } from '@euler/model/bi/viz';
import {
  BiGalleryCategory,
  BiGalleryCategoryKey,
  BiGalleryDashboardCard,
} from '../functions/biGalleryTypes';
import {
  cents,
  kGalleryFields as f,
  galleryReady,
  galleryResult,
} from './biGalleryFields';

const trend: BiChartViz = {
  type: BiVizType.Line,
  x: f.month.key,
  series: [{ key: f.revenue.key }],
};

const kRolling = {
  kind: BiTimeRangeKind.Rolling,
  unit: BiTimeGrain.Month,
  count: 3,
  includeCurrent: true,
} as const;

const rolling: BiGalleryDashboardCard = {
  surface: 'dashboard',
  title: '最近3个月营收',
  viz: trend,
  data: galleryReady(
    galleryResult(
      [f.month, f.revenue],
      [
        ['2026-08', cents(263900)],
        ['2026-09', cents(248700)],
        ['2026-10', cents(151200)],
      ],
      { from: '2026-08-01', to: '2026-10-17' },
    ),
  ),
};

const restricted: BiGalleryDashboardCard = {
  surface: 'dashboard',
  title: '技师提成排行',
  viz: { ...trend, type: BiVizType.HorizontalBar },
  data: { kind: 'restricted' },
};

export const kStatesCategory: BiGalleryCategory = {
  key: BiGalleryCategoryKey.States,
  name: '状态',
  description: '加载中、过期、失败、无权限、无数据、日期筛选、滚动区间',
  preview: restricted,
  variants: [
    {
      key: 'loading',
      name: '加载中',
      card: {
        surface: 'dashboard',
        title: '月度营收',
        viz: trend,
        data: { kind: 'loading' },
      },
    },
    {
      key: 'expired',
      name: '已过期（对话中）',
      note: '草稿超过 30 天',
      card: {
        surface: 'chat',
        title: '上月营收趋势',
        state: { kind: 'expired', message: '这张图表已过期，请重新提问生成。' },
      },
    },
    {
      key: 'failed',
      name: '加载失败',
      note: '可重试',
      card: {
        surface: 'dashboard',
        title: '月度营收',
        viz: trend,
        data: { kind: 'failed', message: '这张图表没有加载出来。' },
      },
    },
    {
      key: 'restricted',
      name: '无权限',
      note: '角色不能读取图表用到的字段：只显示标题',
      card: restricted,
    },
    {
      key: 'empty',
      name: '无数据',
      card: {
        surface: 'dashboard',
        title: '本周退款金额',
        viz: trend,
        data: galleryReady(galleryResult([f.month, f.revenue], [])),
      },
    },
    {
      key: 'date-ignored',
      name: '未应用日期筛选',
      note: '数据集没有时间字段，看板的日期范围对它无效',
      card: {
        surface: 'dashboard',
        title: '各品牌在册车辆数',
        viz: {
          type: BiVizType.Bar,
          x: f.brand.key,
          series: [{ key: f.orders.key, name: '车辆数' }],
        },
        data: galleryReady(
          galleryResult(
            [f.brand, f.orders],
            [
              ['大众', 412],
              ['丰田', 268],
              ['本田', 197],
              ['宝马', 121],
            ],
          ),
          { dateFilter: BiDateFilterUse.Ignored },
        ),
      },
    },
    {
      key: 'rolling',
      name: '滚动区间标注',
      note: `${biRollingLabel(kRolling)}：标题下显示解析后的日期`,
      card: rolling,
    },
    {
      key: 'rolling-kpi',
      name: '滚动区间 · 指标卡',
      note: '上期的日期写在上期数值后',
      card: {
        surface: 'dashboard',
        title: '最近30天营收',
        viz: {
          type: BiVizType.Kpi,
          value: f.revenue.key,
          compare: BiKpiCompare.PreviousPeriod,
        },
        data: galleryReady(
          galleryResult([f.revenue], [[cents(512600)]], {
            from: '2026-09-18',
            to: '2026-10-17',
          }),
          {
            previous: galleryResult([f.revenue], [[cents(486100)]], {
              from: '2026-08-19',
              to: '2026-09-17',
            }),
          },
        ),
      },
    },
  ],
};
